export enum VerticalSlicedMicroFrontendRoutes {
  platform = '/platform',
  loans = '/loans',
  map = '/map',
  quicksight = '/platform/insights',
  quiqproperty = '/platform/quiqproperty',
  workflows = '/workflows',
  opex = '/opex',
  notifications = '/notifications',
  portfolioAssistant = '/assistant/portfolios',
}

export enum RemoteAppNames {
  sidebar = 'sidebarApp',
  platform = 'platformApp',
  loans = 'loansApp',
  map = 'mapApp',
  globalFilters = 'globalFiltersApp',
  workflows = 'ingestionWorkflowsApp',
  opex = 'opexApp',
  notifications = 'notificationCenterApp',
  portfolioAssistant = 'portfolioAssistantApp',
}
